import {https, httpsFile} from './http.js';

export function index(page, currentpage,sortby,sortdir,search,show_filter,mat_grp_filter,mat_grp_1_filter) {
    return httpsFile().get(`inventory_ordering?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}&show_filter=${show_filter}&mat_grp_filter=${mat_grp_filter}&mat_grp_1_filter=${mat_grp_1_filter}`);
}
export function showPending(page, currentpage,sortby,sortdir,search,plant) {
    return httpsFile().get(`showPending?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}`);
}
export function showIncomingContainers(page, currentpage,sortby,sortdir,search,status,blNo) {
    return httpsFile().get(`showIncomingContainers?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&blNo=${blNo}`);
}
export function getComingDetails(matnr) {
    return httpsFile().get(`getComingDetails?matnr=${matnr}`);
}
export function getContainerDetails(container_name,search,currentpage,page) {
    return httpsFile().get(`getContainerDetails?container_name=${container_name}&search=${search}&currentpage=${currentpage}&page=${page}`);
}
export function showAllocRsvMaterials(search,currentpage,page) {
    return httpsFile().get(`showAllocRsvMaterials?search=${search}&currentpage=${currentpage}&page=${page}`);
}
export function getReservationMat(matnr,page,currentpage) {
    return httpsFile().get(`getReservationMat?matnr=${matnr}&currentpage=${currentpage}&page=${page}`);
}
export function updateContainerDetails(container_name,bl_no,eta) {
    return httpsFile().get(`updateContainerDetails?container_name=${container_name}&bl_no=${bl_no}&eta=${eta}`);
}
export function getMaterialGroups() {
    return httpsFile().get(`getMaterialGroups`);
}
export function update_reservation(id,status) {
    return httpsFile().get(`update_reservation?id=${id}&status=${status}`);
}
export function exportData(data) {
    return httpsFile().post(`exportData`,data);
}
export function create_reservation(data) {
    return httpsFile().post(`create_reservation`,data);
}
export function history(page, currentpage,sortby,sortdir,search,plant,year) {
    return httpsFile().get(`inventory_ordering_history?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}`);
}

export function searchBLNo(search,offset){
    return https().get(`/searchBLNo?search=${search}&offset=${offset}`);
}
export function searchPort(search,offset){
    return https().get(`/searchPort?search=${search}&offset=${offset}`);
}

export function showOfftakeReport(page, currentpage,sortby,sortdir, search,status, plant, supplier, category,item_type, isDataTable, matGrp2, prodHier, received_as_of) {
    return httpsFile().get(`showOfftakeReport?page=${page}&currentpage=${currentpage}&sortby=${sortby}
    &sortdir=${sortdir}&search=${search}&status=${status}&plant=${plant}&supplier=${supplier}&category=${category}&item_type=${item_type}&isDataTable=${isDataTable}&matGrp2=${matGrp2}&prodHier=${prodHier}&received_as_of=${received_as_of}`);
}

export function exportOfftakeReport( search,status, plant, supplier, category,item_type, export_page,matGrp2, prodHier,received_as_of) {
    return httpsFile().get(`exportOfftakeReport?search=${search}&status=${status}&plant=${plant}&supplier=${supplier}&category=${category}&item_type=${item_type}&export_page=${export_page}&matGrp2=${matGrp2}&prodHier=${prodHier}&received_as_of=${received_as_of}`
        ,{
            maxContentLength: 1000000000,
            maxBodyLength: 10000000000
        });
}

export function showMonthlyOfftake(details) {
    return httpsFile().post(`showMonthlyOfftake`,details);
}

export function updateOfftakeTempTable(details) {
    return httpsFile().post(`updateOfftakeTempTable`,details);
}

export function showRunningBalance(details) {
    return httpsFile().post(`showRunningBalance`,details);
}

// export function getBegBal(page, currentpage,sortby,sortdir,search,plant,year) {
//     return httpsFile().get(`getBegBal?page=${page}&currentpage=${currentpage}
//     &sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}&year=${year}`);
// }

// export function stock_card_show(page, currentpage,sortby,sortdir,startDate,endDate,lgort,matnr,trans_type,year,search,showTotals,selectedDate){
//     return https().get(`stock_card_show?page=${page}&currentpage=${currentpage}
//     &sortby=${sortby}&sortdir=${sortdir}&startDate=${startDate}&endDate=${endDate}&lgort=${lgort}&matnr=${matnr}&trans_type=${trans_type}&year=${year}
//     &search=${search}&showTotals=${showTotals}&selectedDate=${selectedDate}`);
// }
//
// export function showReceivingReport(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate) {
//     return httpsFile().get(`showReceivingReport?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}`);
// }
//
// export function showReceivingReportDetails(id){
//     return https().get(`showReceivingReport/${id}`);
// }
//
// export function upload_begbal(data){
//     return https().post(`upload_begbal`,data);
// }
//
// export function getDelivered(MATNR,EBELN,EBELP){
//     return https().get(`getDelivered?MATNR=${MATNR}&EBELN=${EBELN}&EBELP=${EBELP}`);
// }
// export function getStatus(EBELN){
//     return https().get(`getStatus?EBELN=${EBELN}`);
// }
//
// export function getRequestedQty(MATNR,EBELN){
//     return https().get(`getRequestedQty?MATNR=${MATNR}&EBELN=${EBELN}`);
// }


export function store(data){
    return https().post(`inventory_ordering`,data);
}
export function create_inventory_report(data){
    return https().post(`create_inventory_report`,data);
}